export default "__VITE_ASSET__BXnd9UK___"